import { render } from "./impact.vue?vue&type=template&id=5de53747&scoped=true"
import script from "./impact.vue?vue&type=script&lang=js"
export * from "./impact.vue?vue&type=script&lang=js"

import "./impact.vue?vue&type=style&index=0&id=5de53747&scoped=true&lang=css"

import exportComponent from "/Users/agroinnovatech/Development/Agro-Innova/AgroInnovaWebsite/AgroInnovaWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de53747"]])

export default __exports__